import { render } from "./Learn.vue?vue&type=template&id=914f7aea&ts=true"
import script from "./Learn.vue?vue&type=script&lang=ts"
export * from "./Learn.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__